<template>
  <div class="login">
      <div class="po">
        <div class="loginLogo">
          <img src="../../assets/images/loginLogin.png" alt="">
          <span>Cloud Money register</span>
        </div>
        <div class="login-con">
           <h1>Please verify your email addree</h1>
           <p style="color: #C9B25F;">Email Verification</p>
           <p style="margin: 30px 0;line-height: 22px;">You need to confirm your email address is valid. Please click the link below to confirm you received this mail in 30 minutes.</p>
           <p>confirm url: <span class="mail">http://xxxx.xxxxx.com/xxxxxxxxxxxxxx</span></p>
           <el-button class="btn" type="primary" @click="login">Create your account</el-button>
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'successRegisterMailEn',
  data() {
    return {

    }
  },
  created(){

  },
  mounted() {

  },
   methods: {
     login() {
       this.$router.push({
         name: "successRegisterEn",
         query: {

         }
       })
     }
  },
  components: {

  }
}
</script>

<style lang="scss" scoped>
  .login{
    background-color: rgb(240, 242, 245);
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/loginBg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    background-attachment:fixed
  }
  .login-con{
    width: 340px;
    padding: 20px 30px 50px 30px;
    background-color: #fff;

  }
  .po{
    position: fixed;
    right: 10%;
    top: 18%;
  }
  .password{
    margin-top: 10px;
  }
  .btn{
    width: 100%;
    margin-top: 40px;
  }
  .loginLogo{
    z-index: 9999;
    overflow: hidden;
    margin-bottom: 20px;
  }
  .loginLogo img{
    float: left;
    width: 70px;
    height: 50px;
    margin-left: 0px;
  }
  .loginLogo span{
    float: left;
    color: #fff;
    margin-left: 25px;
    font-size: 26px;
    margin-top: 14px;
    letter-spacing: 1.6px;
  }
  .register{
    display: block;
    width: 56px;
    margin: 5px auto 0!important;
  }
  .xx{
    overflow: hidden;
  }
  .password{
    float: left;
    width: 242px;
    margin-top: 10px;
  }
  .yaz{
    float: left;
    width: 92px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    background-color: #C9B25F;
    margin-left: 15px;
    margin-top: 10px;
    cursor: pointer;
  }
  .ipt .el-input{
    margin-top: 10px;
  }
  .successRegister{
    display: block;
    width: 90px;
    height: 90px;
    margin: 20px auto;
  }
  .login-con h1{
    font-size: 24px;
    text-align: center;
    margin-bottom: 30px;
  }
  .right-menu{
    float: right;
    height: 100%;
    line-height: 60px;

    .hover-effect {
      cursor: pointer;
      padding: 0 10px;
      transition: background .5s;

      span{
        outline: none;
      }
      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }
  }
  .el-dropdown{
    color: #fff;
  }
  .mail{
    color: #017AFF;
    line-height: 22px;
    word-wrap: break-word;
    white-space: normal;
    word-break: break-all;
  }
</style>
